import log from "loglevel";
log.setDefaultLevel("trace");
export { log };
